import React, { useEffect, useState } from 'react';
import { Clock3Icon } from 'lucide-react';
function getTimeUntilMidnight() {
  const now = new Date();
  const midnight = new Date(now);
  midnight.setHours(24, 0, 0, 0);
  return Math.max(0, midnight.getTime() - now.getTime());
}
function formatCountdown(milliseconds: number) {
  const totalSeconds = Math.ceil(milliseconds / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  return [hours, minutes, seconds].map(value => String(value).padStart(2, '0')).join(':');
}
export function AnnouncementBar() {
  const [remainingTime, setRemainingTime] = useState(getTimeUntilMidnight);
  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setRemainingTime(getTimeUntilMidnight());
    }, 1000);
    return () => window.clearInterval(intervalId);
  }, []);
  const countdown = formatCountdown(remainingTime);
  return <div className="w-full bg-gold text-deep-blue" data-id="element-15" data-mp="689ufwta8n3q">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-x-3 gap-y-1 px-4 py-2.5 text-center" data-id="element-16" data-mp="67gxtoo1fdzb">
        <p className="text-[13px] font-extrabold uppercase tracking-wide sm:text-sm" data-id="element-17" data-mp="a7r0osgj9o9y">
          Oferta limitada de hoy · 50% OFF
        </p>
        <span className="hidden h-4 w-px bg-deep-blue/30 sm:block" aria-hidden="true" data-id="element-18" data-mp="18ng1k1px0tc" />
        <p className="inline-flex items-center gap-1.5 text-[13px] font-semibold sm:text-sm" data-id="element-19" data-mp="oyzyvpyi4hyp">
          <Clock3Icon className="h-4 w-4" aria-hidden="true" data-id="element-20" data-mp="txunx9n2b2r9" />
          Termina en
          <time dateTime={`PT${countdown}`} className="rounded-md bg-deep-blue px-2 py-0.5 font-mono font-bold tracking-wider text-white" aria-label={`La oferta termina en ${countdown}`} data-id="element-21" data-mp="tznoc7730qqt">
            {countdown}
          </time>
        </p>
      </div>
    </div>;
}